import Vue from 'vue'
import Modal from '@/components/Modal.vue'

Vue.component('Modal',Modal)
